import { render } from "./ExtrasLimitsUsage.vue?vue&type=template&id=b460acfe&scoped=true"
import script from "./ExtrasLimitsUsage.vue?vue&type=script&lang=js"
export * from "./ExtrasLimitsUsage.vue?vue&type=script&lang=js"

import "./ExtrasLimitsUsage.vue?vue&type=style&index=0&id=b460acfe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b460acfe"]])

export default __exports__